import React from 'react';
import TicketRaised from 'public/svgs/ticket-raised.svg';
import Dialog from '@/components/ui/Dialog';

export default function TicketRaisedDialog({ isOpen, onOpenChange }) {
  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      closable
      className="landscape:max-w-sm"
    >
      <div className="flex items-center justify-center max-w-sm">
        <TicketRaised className="w-48 max-w-screen-sm landscape:w-24" />
      </div>
      <h2 className="mb-2 font-semibold text-center text-dimmed font-lg/loose">
        Ticket Raised successfully
      </h2>
      <div className="text-center text-sm leading-[24px] font-normal text-dimmed/60">
        We have received your Issue, don’t worry our team is on it
      </div>
    </Dialog>
  );
}
